export default "__VITE_ASSET__ByB6OL05__ 584w";